/**
 * Amazon-style hover preview for product thumbnails + lightbox navigation.
 */
(function () {
  function enableHoverPreview(gallery) {
    if (gallery.dataset.buyspareHover === 'true') return;
    gallery.dataset.buyspareHover = 'true';

    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return;

    const mql = window.matchMedia('(min-width: 750px)');

    thumbs.querySelectorAll('[data-target]').forEach((item) => {
      const button = item.querySelector('button');
      if (!button) return;

      const activate = () => {
        if (!mql.matches) return;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(item.dataset.target, false);
        }
        item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };

      button.addEventListener('mouseenter', activate);
      button.addEventListener('focus', activate);
    });
  }

  function getModalSlides(modal) {
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return [];
    return Array.from(content.children).filter((el) => el.hasAttribute('data-media-id'));
  }

  function setActiveSlide(modal, index) {
    const slides = getModalSlides(modal);
    if (!slides.length) return;

    const nextIndex = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === nextIndex);
    });

    const current = modal.querySelector('[data-buyspare-modal-current]');
    const total = modal.querySelector('[data-buyspare-modal-total]');
    if (current) current.textContent = String(nextIndex + 1);
    if (total) total.textContent = String(slides.length);

    modal.dataset.buyspareModalIndex = String(nextIndex);
  }

  function enableModalNav(modal) {
    if (modal.dataset.buyspareModalNav === 'true') return;
    modal.dataset.buyspareModalNav = 'true';

    const go = (delta) => {
      const current = Number(modal.dataset.buyspareModalIndex || 0);
      setActiveSlide(modal, current + delta);
    };

    modal.querySelectorAll('[data-buyspare-modal-nav]').forEach((button) => {
      button.addEventListener('pointerup', (event) => {
        // Stop Dawn's media-modal from treating this as a backdrop close.
        event.preventDefault();
        event.stopPropagation();
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        go(button.dataset.buyspareModalNav === 'next' ? 1 : -1);
      });
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });

    // Keep close / counter clicks from bubbling oddly
    modal.querySelectorAll('.product-media-modal__toggle, .product-media-modal__counter').forEach((el) => {
      el.addEventListener('pointerup', (event) => event.stopPropagation());
    });

    // Don't close when clicking the image itself — use X / Esc / backdrop
    modal.querySelector('.product-media-modal__content')?.addEventListener('pointerup', (event) => {
      if (event.target.closest('[data-media-id], img, video, model-viewer, iframe')) {
        event.stopPropagation();
      }
    });

    modal.addEventListener('keyup', (event) => {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowRight') go(1);
      if (event.key === 'ArrowLeft') go(-1);
    });

    // Sync counter when Dawn opens a specific media
    const observer = new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      const slides = getModalSlides(modal);
      const activeIndex = slides.findIndex((slide) => slide.classList.contains('active'));
      if (activeIndex >= 0) {
        const current = modal.querySelector('[data-buyspare-modal-current]');
        const total = modal.querySelector('[data-buyspare-modal-total]');
        if (current) current.textContent = String(activeIndex + 1);
        if (total) total.textContent = String(slides.length);
        modal.dataset.buyspareModalIndex = String(activeIndex);
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'], subtree: true, attributeOldValue: false });

    // Also watch class changes on slides
    const content = modal.querySelector('.product-media-modal__content');
    if (content) {
      observer.observe(content, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(enableHoverPreview);
    document.querySelectorAll('product-modal').forEach(enableModalNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
